export const INITIAL_SOCIAL_REGISTRATION_PHONE_NUMBER_MASK = '*';
export const EMPTY_PHONE_NUMBER_PLACEHOLDER = '0';
